import React from 'react';

import { Box } from '@rbilabs/universal-components';

import Home from 'pages/home';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { t } from 'state/intl/translations';
import { useLoyaltyUserState } from 'state/loyalty/hooks/use-loyalty-user-state';
import { primitive } from 'styles/constants';

export default function HomeScreen() {
  const { triggerSignInAccessibility } = useAuthFlow();
  const signInAccessibilityMsg = triggerSignInAccessibility ? t('visuallyHiddenSignInSuccess') : '';

  useLoyaltyUserState({ refreshOnMountOrFocus: true });

  return (
    <Box
      backgroundColor={primitive.$mayoEggWhite}
      flex={1}
      testID="homepage"
      accessibilityLabel={signInAccessibilityMsg}
      accessibilityRole="alert"
    >
      <Home />
    </Box>
  );
}
